module.exports = __webpack_public_path__ + "static/img/zhangxiaoyu.2276381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/zhangxiaoyu.png
// module id = Kbtc
// module chunks = 1